import { GRAY_100, INPUT_COLOR_BORDER } from "../../../utils/colors";

export const MODAL_COMPETITORS_FROM_MENU = "menu";
export const MODAL_COMPETITORS_FROM_CREATE_WITH_IA = "createWithIA";

export const COMPETITOR_FILTER_ADD_VALUE = "__add_competitor__";

export const COMPETITOR_FILTER_BUTTON_SX = {
  fontSize: 14,
};

export const COMPETITOR_FILTER_BUTTON_ACTIVE_SX = {
  backgroundColor: GRAY_100,
  borderColor: INPUT_COLOR_BORDER,
};

export const COMPETITOR_FILTER_ACTIONS_SX = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexShrink: 0,
};
